export const ROOT = '/help';
export const SEARCH = `${ROOT}/search`;
